export default "__VITE_ASSET__qSGsBUZv__"